import { render } from "./ProductsContainer.vue?vue&type=template&id=94d676fc"
import script from "./ProductsContainer.vue?vue&type=script&lang=js"
export * from "./ProductsContainer.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/products/ProductsContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "94d676fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('94d676fc', __exports__)) {
    console.log('reload')
    api.reload('94d676fc', __exports__)
  }
  
  module.hot.accept("./ProductsContainer.vue?vue&type=template&id=94d676fc", () => {
    console.log('re-render')
    api.rerender('94d676fc', render)
  })

}


export default __exports__